(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/week-picker.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/week-picker.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.WeekPicker = Backbone.Model.extend({
    defaults: {
      numWeeks: 1,
      disableMultiweekButtons: false
    },

    initialize: function() {
      this.listenTo(svs.tipset.models.play, 'change', this.toggleSingleRow);
      this.defaults.numWeeks = svs.tipset.models.gameDefinitions.get(
        'multiDraws'
      )[0];
      var isSelfService = svs.utils.ns.isNamespace(
        'svs.core.config.data.svsconfig.isSelfService'
      )
        ? svs.core.config.data.svsconfig.isSelfService
        : false;

      if (isSelfService) {
        this.listenTo(
          svs.tipset.models.systems,
          'change',
          this.setDisableMultiweekButtons
        );
      }
    },

    setNumDraws: function(numWeeks) {
      this.set('numWeeks', numWeeks, { silent: true });
      this.trigger('nrOfWeeksUpdated');
      this.save();
    },

    clearAll: function() {
      this.set(this.defaults);
    },

    getNumberOfWeeks: function() {
      return this.get('numWeeks');
    },

    toggleSingleRow: function() {
      if (
        svs.tipset.objects.localstorageHandler &&
        svs.tipset.objects.localstorageHandler.dataFromLocalStorage &&
        svs.tipset.objects.localstorageHandler.dataFromLocalStorage.numWeeks
      ) {
        this.set(
          'numWeeks',
          svs.tipset.objects.localstorageHandler.dataFromLocalStorage.numWeeks,
          { silent: true }
        );
        this.trigger('nrOfWeeksUpdated');
      }
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    },

    setDisableMultiweekButtons: function() {
      var disableMultiweekButtons =
        svs.tipset.models.systems &&
        svs.tipset.models.systems.getCurrentSystem()
          ? true
          : false;

      this.set('disableMultiweekButtons', disableMultiweekButtons);
    }
  });
})(Backbone, _, svs);

 })(window);